<script lang="ts">
    export let code: string
    import { fly } from "svelte/transition"
    export let context = "default"
    let play: boolean = false
    let hover: boolean = false
    let w: number

    export const playVideo = () => {
        play = true
    }

    console.log(context)
</script>

<svelte:window bind:innerWidth={w} />

<div
    role="button"
    tabindex="0"
    class="embed-container"
    class:rounder={context !== "episode"}
    on:click={() => (play = !play)}
    on:keypress={() => (play = !play)}
    on:mouseenter={() => (hover = !hover)}
    on:mouseleave={() => (hover = !hover)}
>
    {#if play || context === "default" || w <= 1024}
        <iframe
            src="https://www.youtube.com/embed/{code}?modestbranding=1&rel=0{context === 'episode'
                ? '&autoplay=1'
                : ''}"
            frameborder="0"
            allowfullscreen
            title="YouTube video player"
        />
    {:else}
        <div class="static">
            <img
                src="https://img.youtube.com/vi/{code}/maxresdefault.jpg"
                alt="YouTube Video Thumbnail"
            />
            <svg
                class:hover
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 260 180"
                enable-background="new 0 0 260 180"
                xml:space="preserve"
            >
                <path
                    d="M220,2H40C19.01,2,2,19.01,2,40v100c0,20.99,17.01,38,38,38h180c20.99,0,38-17.01,38-38V40C258,19.01,240.99,2,220,2z
                M102,130V50l68,40L102,130z"
                />
            </svg>
            {#if hover}
                <div class="play" transition:fly={{ duration: 200, y: 100 }}>Play Episode</div>
            {/if}
        </div>
    {/if}
</div>

<style>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  max-width: 100%;
  background: rgb(238, 238, 238);
  background: linear-gradient(128deg, rgb(238, 238, 238) 0%, rgb(204, 204, 204) 100%);
  border-radius: 2rem 2rem 0 0;
  overflow: hidden;
}
@media (max-width: 450px) {
  .embed-container {
    border-radius: 0 !important;
  }
}
.embed-container iframe, .embed-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.embed-container .static {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  place-content: center;
  cursor: pointer;
}
.embed-container .static img {
  position: absolute;
  top: 0;
  left: 0;
}
.embed-container .static svg {
  fill: rgba(255, 0, 0, 0.5);
  width: 100px;
  height: auto;
  position: relative;
  z-index: 3;
  filter: drop-shadow(3px 5px 2px rgba(0, 0, 0, 0.2));
  transition: all 100ms ease-out;
}
.embed-container .static svg.hover {
  fill: rgb(255, 0, 0);
  transform: scale(135%);
}
.embed-container .static .play {
  position: absolute;
  color: white;
  font-weight: bold;
  bottom: 1.3rem;
  right: 1.3rem;
  font-size: 1.3rem;
  background: rgba(0, 0, 0, 0.2);
  padding: 1rem;
  border-radius: 2rem;
}
.embed-container.rounder {
  border-radius: 1rem;
}
</style>
